import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c1ee546"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "openNewLink" }
const _hoisted_2 = { class: "confirmBox" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmBox__title" }, "即将离开协作空间", -1))
const _hoisted_4 = { class: "confirmBox__text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmBox__text__line1" }, " 你即将离开协作空间，为了个人信息安全，请谨慎访问： ", -1))
const _hoisted_6 = { class: "confirmBox__foot" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 停止访问 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 继续访问 ")

import { useRoute } from 'vue-router'
import { NCheckbox, NSpace, NButton, useMessage, NEllipsis } from 'naive-ui'
import { useLocalStorage } from '@vueuse/core'
import Icon from '@teams/common/components/icon'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()
const { link } = route.query
const ignoreHint = useLocalStorage<boolean>('ignoreHint__k.wps.cn', false) // 搜索历史记录
const stopJump = () => {
  window.close()
}
const continueJump = () => {
  let url
  if (link?.includes('http') || link?.includes('http')) {
    url = link
  } else {
    url = 'https://' + link
  }
  window.open(url, '_self')
}
const message = useMessage()
const copyUrl = (url: string) => {
  navigator.clipboard
    .writeText(url)
    .then(() => message.success('复制成功'))
    .catch(() => message.error('复制失败，请重试'))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", {
          class: "confirmBox__text__line2",
          onClick: _cache[0] || (_cache[0] = () => copyUrl(_unref(link) as string))
        }, [
          _createVNode(_unref(NEllipsis), { style: {"max-width":"320px"} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(link)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Icon), {
            name: "url",
            size: 16,
            fill: "#FFFFFF",
            class: "copyUrl",
            stroke: "#ffb03b"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(NSpace), {
          justify: "space-between",
          align: 'center'
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NCheckbox), {
              checked: _unref(ignoreHint),
              "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => (_isRef(ignoreHint) ? (ignoreHint).value = $event : null)),
              label: "不再提醒"
            }, null, 8, ["checked"]),
            _createVNode(_unref(NSpace), { justify: "space-between" }, {
              default: _withCtx(() => [
                _createVNode(_unref(NButton), { onClick: stopJump }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NButton), { onClick: continueJump }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})